const autoNgTemplateLoaderTemplate1 = require('./azureEndpointConfig.html');

angular.module('portainer.azure').component('azureEndpointConfig', {
  bindings: {
    applicationId: '=',
    tenantId: '=',
    authenticationKey: '=',
  },
  templateUrl: autoNgTemplateLoaderTemplate1,
});
